import { DealActions, DealDetail } from 'api'
import { isOpenFin } from 'utils'
import { WindowActions } from 'epics/windowEpic'

import { useModal } from 'view/shared/modal'
import { useDispatch } from 'react-redux'
import { CollateralBasketAllocationDialog } from 'view/shared/allocationDialogs'
import React from 'react'

export const useShowAllocationDialog = () => {
  const dispatch = useDispatch()
  const { showModal } = useModal()

  return function showAllocationDialog(dealDetail: DealDetail) {
    if (!dealDetail.collateralBasket) {
      return
    }

    dispatch(DealActions.startAllocations(dealDetail.deal.dealId))

    // TODO JB delay the showModal until we get a startAllocations response
    if (isOpenFin()) {
      dispatch(WindowActions.openAllocationDialog(dealDetail.deal.dealId, dealDetail.collateralBasket.name ?? ''))
    } else {
      setTimeout(() => {
        showModal(<CollateralBasketAllocationDialog dealId={dealDetail.deal.dealId} />)
      }, 300)
    }
  }
}
